'use client';

import { ReactNode, createContext, useCallback, useContext } from 'react';
import { aboutUsTranslations } from './translations';
import { Languages } from '../type';
interface LanguageContextType {
  language: Languages;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  language,
  children
}: {
  language: Languages;
  children: ReactNode;
}) => {
  const t = useCallback((key: string) => {
    const translations = aboutUsTranslations[language];
    const keys = key.split('.');
    let result: unknown = translations;
    for (const k of keys) {
      if (result && typeof result === 'object' && k in result) {
        result = (result as Record<string, unknown>)[k];
      } else {
        return key;
      }
    }
    return typeof result === 'string' ? result : key;
  }, [language]);
  return <LanguageContext.Provider value={{
    language,
    t
  }} data-sentry-element="unknown" data-sentry-component="LanguageProvider" data-sentry-source-file="language-context-provider.tsx">{children}</LanguageContext.Provider>;
};
export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};